import { Sparkles } from "lucide-react";
import { MayaMark } from "@/components/site/BrandLockup";
import { useTranslation } from "react-i18next";

/** Franja final compacta: abre el asistente Maya actual (evento concierge:open). */
export function MayaFinalCta() {
  const { t } = useTranslation();
  return (
    <section aria-label={t("homeV2.finalTitle")} className="bg-background">
      <div className="mx-auto max-w-[1360px] px-4 py-10 sm:px-6 lg:px-8">
        <div className="flex flex-col items-start gap-4 rounded-[22px] border border-gold/50 bg-white px-6 py-6 shadow-[0_14px_36px_-22px_rgba(23,23,23,0.35)] sm:flex-row sm:items-center sm:justify-between sm:px-8">
          <div className="flex min-w-0 items-center gap-4">
            <MayaMark size={56} />
            <div className="min-w-0">
            <h2 className="font-display text-2xl font-semibold tracking-tight text-foreground">
              {t("homeV2.finalTitle")}
            </h2>
            <p className="mt-1 text-sm text-muted-foreground">{t("homeV2.finalDesc")}</p>
            </div>
          </div>
          <button
            type="button"
            onClick={() => window.dispatchEvent(new CustomEvent("concierge:open"))}
            className="inline-flex min-h-[44px] shrink-0 items-center gap-2 rounded-full bg-primary px-6 text-[12px] font-bold uppercase tracking-[0.14em] text-primary-foreground shadow-[0_14px_30px_-14px_rgba(255,138,0,0.8)] transition-transform hover:scale-[1.02] active:scale-[0.98]"
          >
            <Sparkles className="h-4 w-4" aria-hidden /> {t("homeV2.finalCta")}
          </button>
        </div>
      </div>
    </section>
  );
}
